<template>
    <div class="wrapper">
        <v-header></v-header>
        <el-container>
            <el-container>
                <el-main>
                    <div class="content">
                        <transition name="move" mode="out-in">
                            <keep-alive :include="tagsList">
                                <router-view></router-view>
                            </keep-alive>
                        </transition>
                        <el-backtop target=".content"></el-backtop>
                    </div>
                </el-main> 
            </el-container>
        </el-container>
        <!-- foooter -->
        <div class="footer" style="display:none;">
            <v-footer></v-footer>
        </div>
    </div>
</template>

<script>

import vHeader from "./components/Header";
import vFooter from "./components/Footer";
import { mapState, mapMutations } from 'vuex';
import bus from '@/assets/js/bus';
export default {
    name: "Home",
    data() {
        return {
            tagsList: [],
            showChart: true,
        }
    },
    components: {
        vHeader,
        vFooter
    },
    computed: {
        ...mapState(['isCollapse', 'user_info']),
    },
    created() {
        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
    },
    methods: {
        ...mapMutations(['setUserInfo']),
        getUserInfo() {
            this.http.fetchGet(this.api.user_info).then((res) => {
                var data = res.data;

                this.setUserInfo(data);
            }
            ).catch(err => {
                console.log(err)
            })
        },
        flash() {
            this.showChart = false;
            setTimeout(() => {
                this.showChart = true;
                this.$nextTick(() => {
                    this.$refs.charts.showCharts = true;
                })
            }, 0)
        }
    },
    mounted() {
        // 获取用户信息
        // this.getUserInfo();
    }
}
</script>

<style lang="stylus" scoped>
    @import "~@/assets/css/varibles.styl"
    .el-header
        line-height $hdHeight
        height $hdHeight !important
        position absolute
        left 0
        right 0
        top 0
        /*padding-bottom: 30px;*/
        -webkit-transition: left .3s ease-in-out
        transition: left .3s ease-in-out
        background: #3879ed
        color #fff
        padding 0

    .el-main
        padding 0
        -webkit-transition left .3s ease-in-out
        transition left .3s ease-in-out
        background $bgColor

    .main-notCollapse
        position absolute
        left $SbWidth
        right 0
        top $hdHeight
        bottom 0

    .main-collapse
        position absolute
        left $SbCWidth
        right 0
        top $hdHeight
        bottom 0

    /*.wrapper
        overflow hidden*/
</style>
